import { useMutation } from "@apollo/client/react";import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Grid } from "@mui/material";
import CardBox from "../../CardBox/CardBox";
import { RenderInputByTypeMobile } from "../../../../../../components/formGroupGenerator/RenderInputByTypeMobile";
import { useVisita } from "../../../../../../context/VisitaContext";
import SAVE_PARAMETROS_CONTROL_CLINICO_AE, { adaptAddVisitaParametrosControlClinicoInput } from "../../../../../../data/graphQL/mutations/Visitas/saveVisitaParametrosControlClinicoAE";

import { useStepSave } from "../../../../hooks/useStepSave";
import { validateStepFields } from "../../../../utils/visitaStepValidation";

export default function ParametrosControlClinico({ esUrgencia, readOnly, onSaveRef, onExposeFormatted }) {
  const [formData, setFormData] = useState({});

  const { visita, setVisita } = useVisita();

  const [save] = useMutation(SAVE_PARAMETROS_CONTROL_CLINICO_AE);

  const formattedInputs = useMemo(() => {
    return inputs.map((input) => {
      const newInput = { ...input };

      if (esUrgencia) newInput.required = false;

      if (readOnly) newInput.disabled = true;

      return newInput;
    });
  }, [readOnly, esUrgencia]);

  const handleChange = useCallback((name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  }, []);

  useStepSave(onSaveRef, async (validate) => {
    if (validate) validateStepFields({ formattedInputs, formData });

    const { data } = await save({ variables: { ...adaptAddVisitaParametrosControlClinicoInput(formData) } });

    const idParametrosControlClinico = data?.saveVisitaParametrosControlClinicoAE?.idParametrosControlClinico;
    if (!idParametrosControlClinico) throw new Error("Error al guardar");

    setVisita((prev) => ({
      ...prev,
      ...formData,
      idParametrosControlClinico: idParametrosControlClinico
    }));

  });

  useEffect(() => {
    setFormData(visita);
  }, [visita]);

  useEffect(() => {
    onExposeFormatted?.({
      stepId: 'parametrosControlClinico',
      stepName: 'Parametros de control clínico',
      formattedInputs
    });
  }, [onExposeFormatted, formattedInputs]);

  return (
    <CardBox title="Parámetros de control clínico">
      <Grid container spacing={2}>
        {formattedInputs.map((input) =>
        <Grid size={{ xs: 12 }} key={input.name}>
            <RenderInputByTypeMobile
            input={input}
            value={formData[input.name]}
            handleChange={handleChange} />
          
          </Grid>
        )}
      </Grid>
    </CardBox>);

}

const inputs = [
{
  name: "comoSintioDias",
  displayName: "¿Cómo se sintió los últimos días?",
  type: "long_string",
  maxLength: 250,
  required: true
},
{
  name: "modifAnimoActividad",
  displayName:
  "¿Hubo modificaciones en su estado de ánimo o actividad Física?",
  type: "long_string",
  maxLength: 250,
  required: true
},
{
  name: "sienteDolor",
  displayName: "¿Siente o tuvo algún tipo de dolor?",
  type: "boolean",
  maxLength: 250,
  required: true
},
{
  name: "comoSienteAbdomen",
  displayName: "¿Cómo siente a su abdomen?",
  type: "long_string",
  maxLength: 250,
  required: true
},
{
  name: "tuvoFiebre",
  displayName: "¿Tuvo fiebre?",
  type: "boolean",
  lightTitle: true,
  required: true
},
{
  name: "presion",
  displayName: "¿Cómo está su presión?",
  type: "long_string",
  maxLength: 250,
  required: true
},
{
  name: "observaTitle",
  displayName: "¿Tuvo algunas de estas situaciones los últimos días?",
  type: "text",
  sxText: {
    fontWeight: "bold",
    fontSize: "15px"
  }
},
{
  name: "nauseas",
  displayName: "Náuseas",
  type: "boolean",
  lightTitle: true,
  required: true
},
{
  name: "vomito",
  displayName: "Vómito",
  type: "boolean",
  lightTitle: true,
  required: true
},
{
  name: "diarrea",
  displayName: "Diarrea",
  type: "boolean",
  lightTitle: true,
  required: true
},
{
  name: "constipacion",
  displayName: "Constipación",
  type: "boolean",
  lightTitle: true,
  required: true
},
{
  name: "controlGlucemia",
  displayName: "¿Usted se realiza control de glucemia u otro control?",
  type: "long_string",
  maxLength: 250,
  required: true
},
{
  name: "llamadaMedicoMotivo",
  displayName: "¿Tuvo que llamar a su médico por algún motivo?",
  type: "long_string",
  maxLength: 250,
  required: true
}];